/**
 * DEV-ONLY: Read-only introspection helpers for Smart Inspector (and tests).
 */

/**
 * @param {Element | null} el
 * @returns {{
 *   tagName: string;
 *   classList: string[];
 *   inlineCustomProperties: Record<string, string>;
 *   computedCustomProperties: Record<string, string>;
 * } | null}
 */
export function getElementIntrospection(el) {
  if (!el || el.nodeType !== 1 || !el.style) return null;
  const tagName = el.tagName?.toLowerCase() ?? "";
  let classList = [];
  if (typeof el.className === "string") {
    classList = el.className.split(/\s+/).filter(Boolean);
  } else if (el.classList && typeof el.classList.forEach === "function") {
    el.classList.forEach((c) => classList.push(c));
  }

  const inlineCustomProperties = {};
  try {
    const st = el.style;
    for (let i = 0; i < st.length; i++) {
      const prop = st[i];
      if (prop && prop.startsWith("--")) {
        inlineCustomProperties[prop] = st.getPropertyValue(prop).trim();
      }
    }
  } catch {
    // ignore
  }

  let computedCustomProperties = {};
  try {
    const cs = window.getComputedStyle(el);
    computedCustomProperties = Object.fromEntries(
      Object.keys(inlineCustomProperties).map((name) => [name, cs.getPropertyValue(name).trim()])
    );
  } catch {
    computedCustomProperties = {};
  }

  return {
    tagName,
    classList,
    inlineCustomProperties,
    computedCustomProperties,
  };
}
